import React from 'react'
import { devicesIcons } from '@app/lib/MyDevices/devicesIcons'
import { checkIconNumber } from '@app/helpers/myDevices/checkIconNumber'

export const renderIcon = (iconId: number, innerProps: {}): JSX.Element => (React.cloneElement(devicesIcons[checkIconNumber(iconId)], { ...innerProps }))
